var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudSvgrepoCom2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.9999C18.2496 18.9715 19.4432 18.4759 20.3456 17.611C21.2481 16.7462 21.7939 15.5746 21.8754 14.3273C21.957 13.0801 21.5684 11.8475 20.7863 10.8725C20.0042 9.89749 18.8852 9.25073 17.65 9.05975C17.1768 7.73466 16.2529 6.61822 15.0399 5.90521C13.8269 5.19221 12.4019 4.92799 11.0139 5.15912C9.62597 5.39024 8.36341 6.102 7.4469 7.16962C6.53039 8.23724 6.01826 9.59301 6 10.9999C4.93913 10.9999 3.92172 11.4212 3.17157 12.1713C2.42142 12.9215 2 13.9391 2 14.9999C2 16.0608 2.42142 17.0782 3.17157 17.8283C3.92172 18.5785 4.93913 18.9999 6 18.9999H17Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSvgrepoCom2);
export default __webpack_public_path__ + "static/media/cloud-svgrepo-com (2).923282d3088cfc696ac717da27c3c673.svg";
export { ForwardRef as ReactComponent };